import { useSelector } from 'react-redux'
import { useMemo } from 'react'

import { compareFileRequirements } from './helpers'

import { mediaOrderValidRequestedFilesByProductSelector } from '../../../../../modules/selectors/mediaOrdersBookings'

export default function useAvailableProducts(selectedFileRequirements) {
  // use only not floated - valid requests
  const mediaOrderRequestedFilesByProduct = useSelector(mediaOrderValidRequestedFilesByProductSelector)

  const availableBookedMediaFiles = useMemo(() => {
    // filter out uploaded files from file requirements

    const filteredFileRequirements = mediaOrderRequestedFilesByProduct.map(product => {
      // filter out different file requirements from selected
      const sameFileRequirementOnly = product.files.filter(({ requested_file }) => {
        return compareFileRequirements(selectedFileRequirements, requested_file)
      })

      return {
        ...product,
        files: sameFileRequirementOnly
      }
    })

    return filteredFileRequirements.filter(product => {
      // filter out products which don't have files to upload
      return product.files.length > 0
    })
  }, [mediaOrderRequestedFilesByProduct, selectedFileRequirements])

  return useMemo(() => {
    return availableBookedMediaFiles
  }, [availableBookedMediaFiles])
}
